import { OmbudsmanBanner } from "./ombudsman-banner";

export const OmbudsmanBannerContainer = () => {
  return <OmbudsmanBanner />;
};
